
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/forgotpassword",
      function () {
        return require("private-next-pages/user/forgotpassword.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/forgotpassword"])
      });
    }
  